import React from 'react'
import SocialLink from './SocialLink'

const Footer = () => {
  const date = new Date()
  const year = date.getFullYear()
  return (
    <div>
      <footer className="bg-emerald-700 text-black text-sm text-center p-2">
        <div className="flex  text-2xl text-black justify-center ">
          <SocialLink />
        </div>
        &copy; {year} The Asheville Mountain Boys. All rights reserved.
      </footer>
    </div>
  )
}

export default Footer
